var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    className: "injected-svg",
    "data-src": "/static/media/one-drive.57e53c01.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3037 6.66572V6.66455L22.1684 11.3754L26.8546 9.40278C27.8071 8.99134 28.8339 8.77977 29.8715 8.78114C30.0447 8.78114 30.2156 8.78934 30.3854 8.79987C29.8222 6.6028 28.6329 4.61664 26.9621 3.08281C25.2912 1.54899 23.2108 0.53355 20.9737 0.159931C18.7365 -0.213688 16.4391 0.0706006 14.3605 0.978241C12.2819 1.88588 10.5117 3.37779 9.26514 5.27261L9.38455 5.2691C11.1224 5.26683 12.8263 5.75058 14.3037 6.66572Z",
    fill: "#0364B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3049 6.66455C12.827 5.74962 11.1227 5.26626 9.38451 5.2691L9.2651 5.27261C7.56411 5.29389 5.90106 5.77824 4.45464 6.67361C3.00821 7.56898 1.83309 8.84154 1.05552 10.3545C0.277944 11.8676 -0.0726819 13.5638 0.0413089 15.2612C0.1553 16.9585 0.729599 18.5926 1.7025 19.9881L8.63528 17.0696L11.7189 15.7725L18.5826 12.8832L22.1672 11.3754L14.3049 6.66455Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3853 8.79988C30.2143 8.78791 30.0429 8.78166 29.8714 8.78115C28.8342 8.7803 27.8078 8.99227 26.8557 9.40395L22.1683 11.3754L23.5275 12.189L27.9819 14.857L29.9253 16.0206L36.5712 20.001C37.1751 18.88 37.488 17.6255 37.4814 16.3523C37.4748 15.0791 37.1487 13.8279 36.5332 12.7133C35.9177 11.5987 35.0323 10.6564 33.9582 9.97274C32.8842 9.28903 31.6557 8.88576 30.3853 8.79988Z",
    fill: "#1490DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9253 16.0206L27.982 14.857L23.5275 12.1878L22.1696 11.3754L18.5838 12.8832L11.7201 15.7725L8.63531 17.0696L1.7002 19.9881C2.5622 21.2273 3.71135 22.2395 5.04949 22.9381C6.38764 23.6367 7.875 24.0011 9.38455 24H29.8715C31.2452 24.0005 32.5935 23.629 33.7731 22.9249C34.9528 22.2208 35.9197 21.2104 36.5713 20.001L29.9253 16.0206Z",
    fill: "#28A8EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDrive);
export default __webpack_public_path__ + "static/media/oneDrive.cf3ee5f0461e591d7c4c70862ba290e1.svg";
export { ForwardRef as ReactComponent };